import { render } from "./index.vue?vue&type=template&id=5fb588ca"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabLanguage/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fb588ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fb588ca', __exports__)) {
    api.reload('5fb588ca', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5fb588ca", () => {
    api.rerender('5fb588ca', render)
  })

}


export default __exports__